// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"7dd94d23","924":"6c50933e"}[chunkId] + ".chunk.css";
};